import { NgModule } from '@angular/core';

import { NumberInputDirective } from '#shared/directives/number-input/number-input.directive';

@NgModule({
  exports: [NumberInputDirective],
  declarations: [NumberInputDirective],
})
export class NumberInputModule {}
